import Vue from 'vue'
import Store from 'store'

import CheckoutCart from './CheckoutCart.vue'

const el = '.nti-component--checkout-cart'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                CheckoutCart
            },
            template: '<CheckoutCart />'
        })
    }
}

export default {
    render
}